/**
 * @brisa/ui · facelift/verified-badge/VerifiedBadge
 *
 * Feature: migracao-facelift-v1 · COMPONENT_MAP §1 (verified-badge — extraído de
 * ClubCardFacelift onde estava inline, per 179:164).
 *
 * SVG oficial do PL: estrela 12-pontas em #FFE400 + letra "B" preta.
 * Usado em ClubCardFacelift (bottom acima do nome) e no FilterBar do /clubes
 * (Switch "Aceita Brisa Card", per Figma 194:5214 e 194:5224).
 */
import * as React from 'react';

export interface VerifiedBadgeProps extends React.SVGAttributes<SVGSVGElement> {
  size?: number;
}

export function VerifiedBadge({
  size = 32,
  className,
  'aria-label': ariaLabel = 'Club parceiro',
  ...props
}: VerifiedBadgeProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width={size}
      height={size}
      fill="none"
      aria-label={ariaLabel}
      role="img"
      data-slot="verified-badge"
      className={className}
      {...props}
    >
      <path
        d="M11.4668 30L8.9335 25.7333L4.1335 24.6667L4.60016 19.7333L1.3335 16L4.60016 12.2667L4.1335 7.33333L8.9335 6.26667L11.4668 2L16.0002 3.93333L20.5335 2L23.0668 6.26667L27.8668 7.33333L27.4002 12.2667L30.6668 16L27.4002 19.7333L27.8668 24.6667L23.0668 25.7333L20.5335 30L16.0002 28.0667L11.4668 30Z"
        fill="#FFE400"
      />
      <path
        d="M11.9619 20.4999V11.5559H17.9159C18.3666 11.5559 18.7782 11.6512 19.1509 11.8419C19.5236 12.0239 19.8226 12.2796 20.0479 12.6089C20.2732 12.9382 20.3859 13.3196 20.3859 13.7529C20.3859 14.1862 20.3166 14.5416 20.1779 14.8189C20.0392 15.0962 19.8572 15.3172 19.6319 15.4819C19.4066 15.6379 19.1596 15.7549 18.8909 15.8329V15.8849C19.2029 15.9542 19.4846 16.0756 19.7359 16.2489C19.9959 16.4136 20.2039 16.6476 20.3599 16.9509C20.5159 17.2542 20.5939 17.6442 20.5939 18.1209C20.5939 18.5976 20.4769 19.0136 20.2429 19.3689C20.0089 19.7242 19.6969 20.0016 19.3069 20.2009C18.9169 20.4002 18.4792 20.4999 17.9939 20.4999H11.9619ZM14.8349 18.4199H17.0189C17.2182 18.4199 17.3786 18.3506 17.4999 18.2119C17.6212 18.0732 17.6819 17.8652 17.6819 17.5879C17.6819 17.4579 17.6516 17.3409 17.5909 17.2369C17.5389 17.1242 17.4609 17.0376 17.3569 16.9769C17.2616 16.9162 17.1489 16.8859 17.0189 16.8859H14.8349V18.4199ZM14.8349 15.0399H16.8109C16.9496 15.0399 17.0666 15.0096 17.1619 14.9489C17.2572 14.8796 17.3309 14.7842 17.3829 14.6629C17.4436 14.5416 17.4739 14.3899 17.4739 14.2079C17.4739 14.0172 17.4089 13.8569 17.2789 13.7269C17.1489 13.5882 16.9929 13.5189 16.8109 13.5189H14.8349V15.0399Z"
        fill="black"
      />
    </svg>
  );
}
